import React from 'react';
import ListCRUD from 'mrf/view/ListCRUD';
import Text from 'styles/basic/Text';
import {useTranslation} from "react-i18next";
import PropTypes from 'prop-types';

export default function UserList({ match }) {

    const {t} = useTranslation();

    function displayRoles(roles, t) {
        return <Text>{roles.map(r => t(r.role.name)).join(', ')}</Text>;
    }
    
    const fields = [
        { name: 'Username', key: 'userName' },
        { name: 'Email',    key: 'email' },
        { 
            name: 'User Roles',   
            key: 'roles',
            map: roles => displayRoles(roles, t)
        },
        { name: 'Is Active?', key: 'isActive', map: isActive => isActive ? t('Yes') : t('No'), },
    ];

    return <ListCRUD
        singular='user'
        resource='users/userRoles'
        fields={fields}
        match={match}
        disableEditButton
    />;
}

UserList.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }).isRequired,
};